<template>

	<div class="board_list">
		<ul class="webzine_list">

			<li class="notice" v-for="(item, index) in noticeList" :id="'item-' + item.idx">
				<a href="javascript:;" @click="goView(item)">
					<figure class="list_thumb" v-if="item.thumbFile !== null">
						<img :src="APIs.BOARD_FILES_SHOW + item.thumbIdx" alt="" style="object-fit: cover; aspect-ratio: 1 / 1;">
					</figure>
					<figure class="list_thumb" v-else>
						<img src="/ssflex/assets/img/common/img_thumb.svg" alt="">
					</figure>
					<div class="list_text">
						<em class="cate">
							<span class="notice_cate">공지</span> <span>{{ item.cateName }}</span>
						</em>
						<strong class="tit">
							<span class="tag mr-2" :class="{ 'end' : (item.statusName === '완료'), 'ing' : (item.statusName === '확인'), 'req' :  !(item.statusName === '완료' || item.statusName === '확인') }" v-if="boardInfo.isStatus && !$options.filters.isEmpty(item.statusCode)">
								<span>{{ item.statusName }}</span>
							</span>
							{{ item.title }}
						</strong>
						<div class="desc">{{ item.contentText }}</div>
					</div>
				</a>
			</li>



			<li v-for="(item, index) in boardList" :id="'item-' + item.idx">
				<a href="javascript:;" @click="goView(item)">
					<figure class="list_thumb" v-if="item.thumbFile !== null">
					<img :src="APIs.BOARD_FILES_SHOW + item.thumbIdx" alt="" style="object-fit: cover; aspect-ratio: 1 / 1;">
					</figure>
					<figure class="list_thumb" v-else>
						<img src="/ssflex/assets/img/common/img_thumb.svg" alt="">
					</figure>
					<div class="list_text">
						<em class="cate"><span class="notice_cate" v-if="item.isNotice">공지</span> {{ item.cateName }}</em>
						<strong class="tit">
							<span class="tag mr-2" :class="{ 'end' : (item.statusName === '완료'), 'ing' : (item.statusName === '확인'), 'req' :  !(item.statusName === '완료' || item.statusName === '확인') }" v-if="boardInfo.isStatus && !$options.filters.isEmpty(item.statusCode)">
								<span>{{ item.statusName }}</span>
							</span>
							{{ item.title }}
						</strong>
						<div class="desc">{{ item.contentText }}</div>
					</div>
				</a>
			</li>

		</ul>
	</div>

</template>

<script>
export default {
	name: "listWebzine",
	props: {
		forApp: {
			type: Boolean,
			default: false,
		},
		boardInfo: Object,
		noticeList: Array,
		boardList: Array,
	},
	data() {

		return {

		}
	},
	created() {

	},
	mounted() {

	},
	methods: {

		goView( _item ) {
			if ( this.forApp ) {
				this.goAppBoard( _item.boardKey, _item.idx )
			}
			this.$emit("goBoardOne", _item.idx);
		}

	},
	watch: {
	}
}
</script>

<style scoped>

</style>